"use client";

import { ThemeToggle } from "@/features/theme/components/ThemeToggle";

export function FloatingThemeToggle() {
  return (
    <div className="fixed right-4 top-4 z-50">
      <ThemeToggle />
    </div>
  );
}
